// ===========================
// Measurement Toggles
// ===========================
var measurementBottleSwitch = false;
var measurementCanSwitch = false;

function measurementBottleSwitcher() {
  measurementBottleSwitch = !measurementBottleSwitch;
  var bottleLink = document.getElementById('att-bottle');
  if (measurementBottleSwitch) {
    window.expivi.setProductAttributeByKey('att-bottle', 'att-bottle-yes');
    bottleLink.dataset.status = 'on';
    bottleLink.classList.add('ui-button-active');
  } else {
    window.expivi.setProductAttributeByKey('att-bottle', 'att-bottle-no');
    bottleLink.dataset.status = 'off';
    bottleLink.classList.remove('ui-button-active');
  }
}

function measurementCanSwitcher() {
  measurementCanSwitch = !measurementCanSwitch;
  var canLink = document.getElementById('att-can');
  if (measurementCanSwitch) {
    window.expivi.setProductAttributeByKey('att-soda-can', 'att-soda-can-yes');
    canLink.dataset.status = 'on';
    canLink.classList.add('ui-button-active');
  } else {
    window.expivi.setProductAttributeByKey('att-soda-can', 'att-soda-can-no');
    canLink.dataset.status = 'off';
    canLink.classList.remove('ui-button-active');
  }
}

// ===========================
// Main DOMContentLoaded
// ===========================
document.addEventListener('DOMContentLoaded', function() {

  // ── Price container ──
  // Populate #priceContainer (inside the mobile ATC button) with the
  // product price so users know what they're buying. Falls back to
  // "Add to Cart" text (also set via CSS ::after as instant fallback).
  function updatePriceContainer(priceText) {
    var el = document.getElementById('priceContainer');
    if (!el) return;
    if (priceText) {
      el.textContent = priceText;
      return;
    }
    // Already has content from a previous call
    if (el.textContent.trim()) return;
    // Try Shopify's global price (base variant, in cents)
    try {
      var variants = window.ShopifyAnalytics &&
                     ShopifyAnalytics.meta &&
                     ShopifyAnalytics.meta.product &&
                     ShopifyAnalytics.meta.product.variants;
      var cents = variants && variants[0] && variants[0].price;
      if (cents && cents > 0) {
        el.textContent = '$' + (cents / 100).toFixed(2) + ' — Add to Cart';
        return;
      }
    } catch(e) {}
    el.textContent = 'Add to Cart';
  }
  updatePriceContainer();

  // ── Lightbox ──
  function updateProductSummary() {
    expivi.saveConfiguration().then(function(configData) {
      var summaryDiv = document.getElementById('xpv-info-lightbox-content-1');
      var imageDiv = document.getElementById('xpv-info-lightbox-content-image');
      summaryDiv.innerHTML = '';
      imageDiv.innerHTML = '';
      var h = document.createElement('p');
      h.innerHTML = '<h3>Your Custom Bong!</h3>';
      summaryDiv.appendChild(h);
      var p = configData.configured_products[0];
      var thumbnail = p.thumbnail;
      if (thumbnail) {
        var img = document.createElement('img');
        img.src = thumbnail;
        img.style.maxWidth = '100%';
        imageDiv.appendChild(img);
      }
      // Update price while we have the config data
      if (p.price) {
        var raw = p.price;
        // Expivi returns price in cents if > 500, else dollars
        var dollars = raw > 500 ? (raw / 100) : raw;
        updatePriceContainer('$' + dollars.toFixed(2) + ' — Add to Cart');
      }
      var ul = document.createElement('ul');
      p.attributes.forEach(function(a) {
        var li = document.createElement('li');
        li.innerHTML = '<b>' + a.attribute_name + ':</b> ' + a.attribute_value_name;
        ul.appendChild(li);
      });
      summaryDiv.appendChild(ul);
    }).catch(function(ex) { console.error(ex); });
  }

  function showLightbox() { document.getElementById('xpv-info-lightbox').style.display = 'flex'; }
  function hideLightbox() { document.getElementById('xpv-info-lightbox').style.display = 'none'; }

  var summaryButton1 = document.getElementById('summaryLightbox');
  if (summaryButton1) {
    summaryButton1.addEventListener('click', function(e) { e.preventDefault(); updateProductSummary(); showLightbox(); });
  }
  var summaryButton2 = document.getElementById('summaryLightbox2');
  if (summaryButton2) {
    summaryButton2.addEventListener('click', function(e) { e.preventDefault(); updateProductSummary(); showLightbox(); });
  }

  var closeButton = document.getElementById('xpv-closeLightbox');
  if (closeButton) { closeButton.addEventListener('click', hideLightbox); }

  var lightboxOverlay = document.getElementById('xpv-info-lightbox');
  if (lightboxOverlay) {
    lightboxOverlay.addEventListener('click', function(e) { if (e.target === lightboxOverlay) hideLightbox(); });
  }
  document.addEventListener('keydown', function(e) { if (e.key === 'Escape') hideLightbox(); });

  var infoLink = document.querySelector('.expivi-info-panel-right #expivi-info-panel-image a');
  if (infoLink) {
    infoLink.addEventListener('click', function(e) {
      e.preventDefault();
      var el = document.querySelector('.ProductSummary');
      if (el) el.scrollIntoView({ behavior: 'smooth' });
    });
  }

  var fullscreenButton = document.getElementById('button-fullscreen');
  if (fullscreenButton) {
    var fullscreenIcon = fullscreenButton.querySelector('i');
    var isFullscreen = false;
    fullscreenButton.addEventListener('click', function(e) {
      e.preventDefault();
      var viewer = document.querySelector('.expivi-viewer-container');
      var canvas = document.querySelector('#viewerContainer canvas');
      if (!viewer || !canvas) return;
      viewer.style.transition = 'height 0.8s ease, z-index 0s';
      canvas.style.transition = 'transform 0.8s ease, margin-top 0.8s ease';
      if (!isFullscreen) {
        viewer.style.height = '80vh'; viewer.style.zIndex = '1002';
        canvas.style.transform = 'scale(2)'; canvas.style.marginTop = '100px';
        fullscreenIcon.classList.replace('fa-expand', 'fa-compress');
      } else {
        viewer.style.height = ''; viewer.style.zIndex = '';
        canvas.style.transform = ''; canvas.style.marginTop = '';
        fullscreenIcon.classList.replace('fa-compress', 'fa-expand');
      }
      isFullscreen = !isFullscreen;
    });
  }

  var bottleLink = document.getElementById('att-bottle');
  if (bottleLink) {
    bottleLink.addEventListener('click', function(e) { e.preventDefault(); measurementBottleSwitcher(); });
  }
  var canLink = document.getElementById('att-can');
  if (canLink) {
    canLink.addEventListener('click', function(e) { e.preventDefault(); measurementCanSwitcher(); });
  }

  var icon = document.getElementById('interactive-icon');
  var panelButton = document.getElementById('expivi-info-panel-button');
  if (icon && panelButton) {
    icon.addEventListener('click', function(e) {
      e.preventDefault();
      if (panelButton.classList.contains('expanded')) {
        panelButton.style.width = '36px';
        setTimeout(function() { panelButton.classList.remove('expanded'); }, 300);
      } else {
        panelButton.classList.add('expanded');
        panelButton.style.width = '180px';
      }
    });
  }

  var embeddedAddToCartBtn = document.getElementById('embedded-add-to-cart-btn');
  if (embeddedAddToCartBtn) {
    embeddedAddToCartBtn.addEventListener('click', function() {
      embeddedAddToCartBtn.innerHTML = '<i class="fa-solid fa-spinner fa-spin"></i> Adding to cart...';
      setTimeout(hideLightbox, 400);
    });
  }

  // Sync measurement toggles + update price on fully_loaded
  window.expivi._events.onChange.subscribe(async function(e) {
    if (e.name === 'fully_loaded') {
      try {
        var result = await window.expivi.saveConfiguration(0, 0, false, false, { include_keys: true });
        var p = result.configured_products[0];
        var attributes = p.configuration.attributes;
        var bLink = document.getElementById('att-bottle');
        var cLink = document.getElementById('att-can');
        if (bLink && cLink) {
          var bottleVal = attributes.filter(function(a) { return a.attribute_key === 'att-bottle'; }).map(function(a) { return a.attribute_value_name; })[0];
          var canVal = attributes.filter(function(a) { return a.attribute_key === 'att-soda-can'; }).map(function(a) { return a.attribute_value_name; })[0];
          if (bottleVal === 'Yes') { bLink.dataset.status = 'on'; bLink.classList.add('ui-button-active'); measurementBottleSwitch = true; }
          else { bLink.dataset.status = 'off'; bLink.classList.remove('ui-button-active'); measurementBottleSwitch = false; }
          if (canVal === 'Yes') { cLink.dataset.status = 'on'; cLink.classList.add('ui-button-active'); measurementCanSwitch = true; }
          else { cLink.dataset.status = 'off'; cLink.classList.remove('ui-button-active'); measurementCanSwitch = false; }
        }
        // Update price container once Expivi is loaded
        if (p.price) {
          var raw = p.price;
          var dollars = raw > 500 ? (raw / 100) : raw;
          updatePriceContainer('$' + dollars.toFixed(2) + ' — Add to Cart');
        }
      } catch(ex) { console.error('Expivi attr error:', ex); }
    }
  });

});


// ================================================================
// MOBILE SCROLL FIX v3
// ================================================================
(function () {
  if (!('ontouchstart' in window)) return;

  function cartOrModalOpen() {
    if (document.querySelector('.CartDrawer[aria-hidden="false"]')) return true;
    var sc = document.getElementById('slidecarthq');
    if (sc && sc.children.length > 0) return true;
    if (document.body.classList.contains('slidecart-open'))   return true;
    if (document.body.classList.contains('cart-drawer-open')) return true;
    var lb = document.getElementById('xpv-info-lightbox');
    if (lb && lb.style.display === 'flex') return true;
    return false;
  }

  function setOptionsHeight() {
    var viewerH  = window.innerHeight * 0.44;
    var buttonsH = 80;
    var h = Math.max(120, window.innerHeight - viewerH - buttonsH);
    document.documentElement.style.setProperty('--xpv-options-h', Math.round(h) + 'px');
  }
  setOptionsHeight();
  window.addEventListener('resize', setOptionsHeight, { passive: true });

  function injectScrollFixStyles() {
    if (document.getElementById('xpv-scroll-fix-v3')) return;
    var s = document.createElement('style');
    s.id = 'xpv-scroll-fix-v3';
    s.textContent = [
      '@media (max-width:600px){',
      '  .expivi-single-product-container .expivi-option-container{',
      '    height:var(--xpv-options-h,calc(56vh - 80px))!important;',
      '    max-height:var(--xpv-options-h,calc(56vh - 80px))!important;',
      '    overflow:hidden!important;',
      '  }',
      '  .expivi-single-product-container .options-container{',
      '    height:100%!important;min-height:0!important;overflow:hidden!important;',
      '  }',
      '  .expivi-single-product-container .options-container .xpv-app-container{',
      '    height:100%!important;max-height:100%!important;',
      '    overflow-y:scroll!important;',
      '    -webkit-overflow-scrolling:touch!important;',
      '    overscroll-behavior-y:contain!important;',
      '  }',
      '  .expivi-single-product-container .xpv-app-container .container{',
      '    overflow:visible!important;',
      '  }',
      '  .horizontal-scroll-tiles,.horizontal-scroll-tiles>*{',
      '    touch-action:pan-x pan-y!important;',
      '  }',
      '}'
    ].join('\n');
    document.head.appendChild(s);
  }

  var _hooked = false;
  function hookExpiviScroll() {
    if (_hooked) return;
    if (!window.expivi || !window.expivi._events || !window.expivi._events.onChange) {
      setTimeout(hookExpiviScroll, 300);
      return;
    }
    _hooked = true;
    window.expivi._events.onChange.subscribe(function () {
      var xpvApp = document.querySelector('.xpv-app-container');
      var savedTop = xpvApp ? xpvApp.scrollTop : 0;
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          var el = document.querySelector('.xpv-app-container');
          if (el && Math.abs(el.scrollTop - savedTop) > 5) el.scrollTop = savedTop;
          document.body.style.overflow = '';
          document.documentElement.style.overflow = '';
          injectScrollFixStyles();
        });
      });
    });
  }

  new MutationObserver(function () {
    if (cartOrModalOpen()) return;
    var b = document.body, h = document.documentElement;
    if (b.style.position === 'fixed') {
      var y = parseInt(b.style.top || '0', 10) * -1;
      b.style.position = ''; b.style.top = ''; b.style.width = '';
      window.scrollTo(0, y);
    }
    if (b.style.overflow === 'hidden') b.style.overflow = '';
    if (h.style.overflow === 'hidden') h.style.overflow = '';
  }).observe(document.body, { attributes: true, attributeFilter: ['style'] });

  document.addEventListener('touchend', function () {
    if (cartOrModalOpen()) return;
    var b = document.body;
    if (b.style.overflow === 'hidden') b.style.overflow = '';
    if (b.style.position === 'fixed') {
      var y = parseInt(b.style.top || '0', 10) * -1;
      b.style.position = ''; b.style.top = ''; b.style.width = '';
      window.scrollTo(0, y);
    }
  }, { passive: true });

  injectScrollFixStyles();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      injectScrollFixStyles();
      setTimeout(hookExpiviScroll, 600);
    });
  } else {
    setTimeout(hookExpiviScroll, 600);
  }

}());
